import React from 'react'

const TemplateContext = React.createContext({ 
        estado: '',
        precisaAtualizar: false,
        atualizarGrade: () => {},
        blockingPanel: false,
        setVisibleBlockingPanel: () => {},
        data: {}, 
        setData: () => {} })

export const TemplateProvider = TemplateContext.Provider

export { TemplateContext }
